import {
  Users,
  Heart,
  Truck,
  MessageSquare,
  DollarSign,
  Briefcase,
  Handshake,
  Settings,
  Wallet,
  Gift,
  Target,
  Smile,
  Frown,
  Zap,
  Package,
  Building2,
  Shuffle,
  Sparkles,
  AlertCircle,
  Clock,
  BarChart3,
  AlertTriangle,
  User,
  Cloud,
  Sun,
  Star,
  type LucideIcon,
} from 'lucide-react'
import {
  CANVAS_TEMPLATES as SHARED_TEMPLATES,
  type CanvasTemplateDef,
  type CanvasSectionDef,
} from '@ispot/shared'

// Canvas section definition (with React icon component)
export interface CanvasSection {
  id: string
  title: string
  icon: LucideIcon
  color: string
  bgColor: string
  classUris: string[]
  gridArea: string
  description: string
  sectionType?: 'default' | 'photo'
}

// Canvas template definition (with React icon components)
export interface CanvasTemplate {
  id: string
  name: string
  description: string
  gridColumns: number
  gridRows: number
  gridAreas: string
  sections: CanvasSection[]
}

// Map icon name strings to Lucide React components
const ICON_MAP: Record<string, LucideIcon> = {
  'handshake': Handshake,
  'settings': Settings,
  'briefcase': Briefcase,
  'heart': Heart,
  'message-square': MessageSquare,
  'truck': Truck,
  'users': Users,
  'wallet': Wallet,
  'dollar-sign': DollarSign,
  'target': Target,
  'smile': Smile,
  'frown': Frown,
  'zap': Zap,
  'gift': Gift,
  'package': Package,
  'building-2': Building2,
  'shuffle': Shuffle,
  'sparkles': Sparkles,
  'alert-circle': AlertCircle,
  'clock': Clock,
  'bar-chart-3': BarChart3,
  'alert-triangle': AlertTriangle,
  'user': User,
  'cloud': Cloud,
  'sun': Sun,
  'star': Star,
}

function mapSection(def: CanvasSectionDef): CanvasSection {
  return {
    id: def.id,
    title: def.title,
    icon: ICON_MAP[def.iconName] || Heart,
    color: def.color,
    bgColor: def.bgColor,
    classUris: def.classUris,
    gridArea: def.gridArea,
    description: def.description,
    sectionType: def.sectionType,
  }
}

function mapTemplate(def: CanvasTemplateDef): CanvasTemplate {
  return {
    id: def.id,
    name: def.name,
    description: def.description,
    gridColumns: def.gridColumns,
    gridRows: def.gridRows,
    gridAreas: def.gridAreas,
    sections: def.sections.map(mapSection),
  }
}

// Build templates from shared definitions
export const BUSINESS_MODEL_CANVAS: CanvasTemplate = mapTemplate(SHARED_TEMPLATES[0])
export const VALUE_PROPOSITION_CANVAS: CanvasTemplate = mapTemplate(SHARED_TEMPLATES[1])
export const POSITIONING_CANVAS: CanvasTemplate = mapTemplate(SHARED_TEMPLATES[2])
export const PROBLEM_STATEMENT_CANVAS: CanvasTemplate = mapTemplate(SHARED_TEMPLATES[3])
export const PERSONA_CANVAS: CanvasTemplate = mapTemplate(SHARED_TEMPLATES[4])

export const CANVAS_TEMPLATES: CanvasTemplate[] = SHARED_TEMPLATES.map(mapTemplate)

export function getCanvasTemplate(id: string): CanvasTemplate | undefined {
  return CANVAS_TEMPLATES.find((t) => t.id === id)
}
